import { documentTypeExpressionDefinitionApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const DOCUMENT_CALCULATION_FIELDS_SCHEMA_TYPE = createNamedActions(
  'documentCalculationFieldsSchema',
  {
    GET_DOCUMENT_CALCULATION_FIELDS_RULE_SCHEMA_PARAMS:
      'GET_DOCUMENT_CALCULATION_FIELDS_RULE_SCHEMA_PARAMS',
  },
);

export const getDocumentCalculationFieldsRuleSchemaParamsAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } =
      await documentTypeExpressionDefinitionApi.getDocumentTypeExpressionDefinitionByDocumentTypeId(
        params,
      );

    return dispatch({
      type: DOCUMENT_CALCULATION_FIELDS_SCHEMA_TYPE.GET_DOCUMENT_CALCULATION_FIELDS_RULE_SCHEMA_PARAMS,
      payload: data,
    });
  },
);
